var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Witaj w Centrum Rozwoju")]),_c('h3',[_vm._v("Cieszymy się, że jesteś z nami!")]),_c('SearchBar')],1),_c('HomePageContainers')],1),_c('HomePageSlider'),_c('HomePageNews')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }